export const MEDIA_BASE_URL = 'https://media.spiggl.com';

export const isProtectedMediaKey = (key) => typeof key === 'string' && /^protected\/[^/]+\/.+/.test(key);

export const isPrivateMediaKey = (key) => typeof key === 'string' && key.startsWith('private/');

const isSafeKey = (key) => !key.includes('..') && !key.includes('://') && !key.startsWith('/');

export const mediaUrl = (key) => {
  if (!key || typeof key !== 'string' || !isSafeKey(key) || isPrivateMediaKey(key)) return '';
  if (isProtectedMediaKey(key) || key.startsWith('public/')) return `${MEDIA_BASE_URL}/${key}`;
  return `${MEDIA_BASE_URL}/public/${key}`;
};
